"use client"

import { useEffect } from "react"
import * as Sentry from "@sentry/react"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6">
      <div className="max-w-md text-center">
        <h2 className="text-xl font-medium text-[var(--text-primary)] mb-3">
          Something went wrong
        </h2>
        <p className="text-sm text-[var(--text-muted)] mb-6">
          An error occurred while loading this page. Our team has been notified.
        </p>
        <button
          onClick={reset}
          className="rounded-lg border border-[var(--border-default)] bg-white px-5 py-2.5 text-sm font-medium text-[var(--text-secondary)] transition-colors hover:border-[var(--gold)]"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
